import AppConfig, { IS_PROD_ENV } from '../AppConfig/index';

export const baseUrl = AppConfig.SSO_HOST_URL;

export const getPolicyGptFrameworkBasePath = (
  organisationId: string,
  memberId: string,
  isV3 = false,
) => {
  const frameworkPath = isV3 ? 'skills-framework' : 'framework';
  return `${baseUrl}/policygpt/${frameworkPath}/organisation/${organisationId}/member/${memberId}`;
};

export const isAnalyticsTurnedOn =
  IS_PROD_ENV || AppConfig.FORCE_ANALYTICS_TURN_ON;
